import React from 'react';
import styled from 'styled-components';

// Routes
import AppRoutes from 'components/routes/app_routes/AppRoutes';

// Templates
import AppTemplate from 'components/templates/AppTemplate/AppTemplate';

// Layout
import Header from 'components/layout/header/Header';
import Footer from 'components/layout/footer/Footer';

const App = () => (
	<AppTemplate>
		<Header />
		<Wrapper>
			<AppRoutes />
		</Wrapper>
		<Footer />
	</AppTemplate>
);

const Wrapper = styled.div`
	height: 100%;
	min-height: 100vh;
	flex: 1;
	display: flex;
	flex-direction: column;
`;

export default React.memo(App);
